import Router from 'next/router';
import { config } from '@/config';
import { trackHelpWidgetOpened } from '@/lib/pageTracking';

const trackLauncherClicks = () => {
  let tracked = false;

  window.addEventListener('blur', () => {
    setTimeout(() => {
      if (tracked || document.activeElement?.id !== 'launcher-frame') return;
      tracked = true;
      trackHelpWidgetOpened(Router.pathname);
    }, 0);
  });

  window.addEventListener('focus', () => {
    tracked = false;
  });
};

const HelpButton = () => {
  const script = document.createElement('script');

  script.src = `https://widget.freshworks.com/widgets/${config().CAREINADVANCE ? '47000005999' : '47000005615'}.js`;
  script.async = true;

  document.body.appendChild(script);
  window.fwSettings = {
    widget_id: config().CAREINADVANCE ? 47000005999 : 47000005615
  };

  !(function () {
    if ('function' != typeof window.FreshworksWidget) {
      var n = function () {
        n.q.push(arguments);
      };
      ((n.q = []), (window.FreshworksWidget = n));
    }
  })();

  trackLauncherClicks();
};

export default HelpButton;
